/**
 *
 * Asynchronously loads the component for Lifetime
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Lifetime = lazyLoad(
  () => import('./index'),
  module => module.Lifetime,
);
